import { InvoiceStatus } from './api';

export const InvoiceStatusFilter = { All: 'ALL', ...InvoiceStatus } as const;

export type InvoiceStatusFilter =
  (typeof InvoiceStatusFilter)[keyof typeof InvoiceStatusFilter];

export interface Invoice {
  id: string;
  number: string;
  service: string;
  amount: number;
  formattedAmount: string;
  status: InvoiceStatus;
  createdDate: string;
  statusDate: string;
  statusDateDetails: string;
  paymentSource?: string;
  printUrl?: string;
  discountPercent?: number;
  formattedVatAmount: string;
  activationDate?: string;
  periodDays?: number;
  period?: string;
  paidAdsCount?: number;
  walletAmount?: number;
  customerName?: string;
  customerTin?: string;
  contractNumber?: string;
  canDownload: boolean;
  canPay: boolean;
}
